'use client';

import { useRouter } from 'next/navigation';
import { useAuth } from '@/context/auth-context';

export default function LogoutButton() {
  const router = useRouter();
  const { logout } = useAuth();

  async function onClick() {
    await logout();
    router.push('/');
    router.refresh();
  }

  return (
    <button type="button" onClick={onClick} className="account-logout-btn">
      Sign out
      <style>{`
        .account-logout-btn {
          background: transparent;
          color: var(--color-text-secondary);
          border: 1px solid var(--color-border);
          padding: 0.5rem 1rem;
          border-radius: 0.5rem;
          font-size: 0.85rem;
          font-weight: 600;
          cursor: pointer;
          transition: border-color 0.15s, color 0.15s;
        }
        .account-logout-btn:hover {
          border-color: var(--color-primary);
          color: var(--color-primary);
        }
      `}</style>
    </button>
  );
}
